import DescribeBusiness from "./DescribeBusiness";
import { useGetBusinessDescriptionQuery } from "types/generated/operations";
import { getProspectUuid } from "utils/idHelpers";
import Loader from "uicomponents/Loader";
import Error from "uicomponents/Error";
interface IDescribeBusinessProps {
  setNextStep: () => void;
  setPreviousStep: () => void;
}

const DescribeBusinessModel = ({ ...props }: IDescribeBusinessProps) => {
  const { data, error, loading } = useGetBusinessDescriptionQuery({
    variables: { uuid: getProspectUuid() },
    fetchPolicy: "no-cache",
  });
  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <Error />;
  }
  return (
    <DescribeBusiness
      setNextStep={props.setNextStep}
      setPreviousStep={props.setPreviousStep}
      data={data?.prospect}
    />
  );
};

export default DescribeBusinessModel;
